import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import Dropdown from 'react-bootstrap/Dropdown';
import ActionConfigModal, { renderActionConfigDetails } from './ActionConfigModal';
import { toast } from 'react-toastify';
import { DYNAMIC_TABLE, GENERIC_REQUEST, getApiPath, LIST } from '../../../api/ApiConst';
import ApiCaller from '../../../api/ApiCaller';
const actionTypes = [
    { id: 'INSERT', label: 'Insert', icon: 'fa-solid fa-plus' },
    { id: 'UPDATE', label: 'Update', icon: 'fa-solid fa-pen-to-square' },
    { id: 'DELETE', label: 'Delete', icon: 'fa-solid fa-trash' },
    { id: 'CALL_API', label: 'Call API', icon: 'fa-solid fa-link' },
    { id: 'SEND_EMAIL', label: 'Send Email', icon: 'fa-solid fa-envelope' },
    { id: 'CONDITION', label: 'Condition', icon: 'fa-solid fa-check-circle' },
];

const WorkflowBuilder = () => {
    const [workflowName, setWorkflowName] = useState('');
    const [selectedRequest, setSelectedRequest] = useState('');
    const [steps, setSteps] = useState([]);
    const [draggedStepIndex, setDraggedStepIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentStepId, setCurrentStepId] = useState(null);
    const [currentAction, setCurrentAction] = useState(null);
    const [customRequestList, setCustomRequestList] = useState([]);
    const [allTableList, setAllTableList] = useState([]);
    const [showStepDetails, setShowStepDetails] = useState(null);

    useEffect(() => {
        fetchAllTableList();
        fetchCustomRequestList();
    }, []);

    const fetchAllTableList = () => {
        var jsonRequest = {
            "page": 0,
            "size": 1000,
            searchFilters: [],
            sortRules: [],
        };
        const url = getApiPath(DYNAMIC_TABLE, LIST);
        ApiCaller.callPostApi(url, jsonRequest, {}, (response) => {
            setAllTableList(response?.data || []);
        }, (error) => {
            console.error(error);
            setAllTableList([]);
        })
    }
    const reindexSteps = (stepList) =>
        stepList.map((step, index) => ({
            ...step,
            id: index + 1,
        }));

    const addStep = () => {
        const newStep = { id: steps.length + 1, actions: [] };
        setSteps((prevSteps) => reindexSteps([...prevSteps, newStep]));
    };

    const insertStepAt = (index) => {
        const newStep = { id: steps.length + 1, actions: [] };
        const newSteps = [...steps];
        newSteps.splice(index + 1, 0, newStep);
        const reindexedSteps = newSteps.map((step, idx) => ({
            ...step,
            id: idx + 1
        }));
        setSteps(reindexedSteps);
    };

    const handleDropAction = (stepId, actionData) => {
        if (steps.find((s) => s.id === stepId)?.actions.length) return;
        const action = JSON.parse(actionData);
        setCurrentStepId(stepId);
        setCurrentAction(action);
        setShowModal(true);
      };
      
    const handleModalSave = (configuredAction) => {
        const updatedSteps = steps.map((step) =>
            step.id === currentStepId
                ? { ...step, actions: [configuredAction] } // only one action per step
                : step
        );
        setSteps(reindexSteps(updatedSteps));
        setShowModal(false);
        setCurrentAction(null);
        setCurrentStepId(null);
    };

    const removeActionFromStep = (stepId, actionIndex) => {
        const updatedSteps = steps.map((step) =>
            step.id === stepId
                ? { ...step, actions: step.actions.filter((_, idx) => idx !== actionIndex) }
                : step
        );
        setSteps(reindexSteps(updatedSteps));
    };

    const reorderSteps = (fromIndex, toIndex) => {
        if (fromIndex === toIndex) return;
        const updatedSteps = [...steps];
        const [moved] = updatedSteps.splice(fromIndex, 1);
        updatedSteps.splice(toIndex, 0, moved);
        setSteps(reindexSteps(updatedSteps));
    };

    const removeStep = (index) => {
        let responseParametersUsed = false;
        let responseParametersUsedStepId = null;

        for (let i = 0; i < steps.length; i++) {
            for (let j = 0; j < steps[i].actions.length; j++) {
                const action = steps[i].actions[j];
                if (action.config?.requestParamSource?.includes(steps[index]?.id)) {
                    responseParametersUsed = true;
                    responseParametersUsedStepId = i;
                    break;
                }
            }
        
            if (responseParametersUsed) {
                break;
            }
        }
        
        if(responseParametersUsed){
            toast.error(`Response parameters used in step ${responseParametersUsedStepId +1}, remove that first`);
            return;
        }
        swal({
            title: "Are you sure?",
            buttons: {
                cancel: true,
                confirm: true,
            },
            text: "Are you sure that you want to remove this step?",
            icon: "warning",
            dangerMode: true,
        }).then((result) => {
            if (result) {
                const updatedSteps = [...steps];
                updatedSteps.splice(index, 1);
                setSteps(reindexSteps(updatedSteps));
            }
        })
    };

    const saveWorkflow = () => {
        if(workflowName?.trim() === ''){
            toast.error('Please enter workflow name');
            return;
        }
        const payload = {
            name: workflowName,
            customRequestId: selectedRequest,
            steps: steps.map((step) => ({
                id: step.id,
                action:{
                    id: step.actions?.[0]?.id,
                    label: step.actions?.[0]?.label,
                    config: step.actions?.[0]?.config,
                },
            })),
        };
        console.log("payload : ",payload)
    };

    const fetchCustomRequestList = () => {
        var jsonRequest = {
            "page": 0,
            "size": 1000,
            searchFilters: [],
            sortRules: [],
        };
        const url = getApiPath(GENERIC_REQUEST, LIST);
        ApiCaller.callPostApi(url, jsonRequest, {}, (response) => {
            setCustomRequestList(response?.data || []);
        }, (error) => {
            console.error(error);
            setCustomRequestList([]);
        })
    }
    
    const isDisabled = !selectedRequest;

    const renderStepContent = (step) => {
        const action = step.actions[0];
        if (!action) return null;

        const tableName = action.config?.tableId 
            ? allTableList.find(t => t.id === action.config.tableId)?.name 
            : null;

        return (
            <div className="step-content">
                <div className="step-header d-flex justify-content-between align-items-center">
                    <strong>Step {step.id}</strong>
                    <Dropdown>
                        <Dropdown.Toggle
                            bsPrefix="m-0"
                            style={{ 
                                fontSize: '20px', 
                                lineHeight: '1', 
                                color: 'black', 
                                backgroundColor: 'transparent', 
                                border: 'none',
                                padding: "4px 10px"
                            }}
                            id={`dropdown-step-${step.id}`}
                        >
                            ⋮
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setShowStepDetails(step.id)}>
                                View Details
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {
                                setCurrentStepId(step.id);
                                setCurrentAction(action);
                                setShowModal(true);
                            }}>
                                Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => removeStep(steps.findIndex(s => s.id === step.id))}
                                className="text-danger"
                            >
                                Remove Step
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="step-info">
                    <div className="info-row">
                        <span className="label">Action:</span>
                        <span className="value">{action.label}</span>
                    </div>
                    {tableName && (
                        <div className="info-row">
                            <span className="label">Table:</span>
                            <span className="value">{tableName}</span>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderConditionalSteps = (step) => {
        const action = step.actions[0];
        if (!action || action.id !== 'CONDITION') return null;

        const trueStep = steps.find(s => s.id === action.config?.conditionalSteps?.[0]?.stepId);
        const falseStep = steps.find(s => s.id === action.config?.elseStepId);

        return (
            <div className="conditional-branches">
                <div className="branches-container">
                    <div className="branch true-branch">
                        <div className="branch-header">
                            <div className="branch-arrow">
                                <div className="arrow-line"></div>
                                <div className="arrow-label">True</div>
                            </div>
                        </div>
                    </div>
                    <div className="branch false-branch">
                        <div className="branch-header">
                            <div className="branch-arrow">
                                <div className="arrow-line"></div>
                                <div className="arrow-label">False</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="branch-steps-container">
                    <div className="branch-steps">
                        {trueStep && (
                            <div className="step-wrapper">
                                <div className="step-container">
                                    {renderStepContent(trueStep)}
                                </div>
                            </div>
                        )}
                        {falseStep && (
                            <div className="step-wrapper">
                                <div className="step-container">
                                    {renderStepContent(falseStep)}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const renderSteps = () => {
        const renderedSteps = [];
        let i = 0;
        
        while (i < steps.length) {
            const step = steps[i];
            const action = step.actions[0];
            
            if (action?.id === 'CONDITION') {
                // For condition step, render it and its branches
                renderedSteps.push(
                    <div key={step.id} className="step-wrapper">
                        <div className="d-flex justify-content-center align-items-center">
                            {i > 0 && (
                                <button
                                    className="insert-step-btn"
                                    onClick={() => {
                                        if (!isDisabled) {
                                            const newStep = { id: steps.length + 1, actions: [] };
                                            const newSteps = [...steps];
                                            newSteps.splice(i, 0, newStep);
                                            setSteps(newSteps.map((step, idx) => ({
                                                ...step,
                                                id: idx + 1
                                            })));
                                        }
                                    }}
                                    title="Add step between"
                                    disabled={isDisabled}
                                >
                                    <span className="arrow-icon">↓</span>
                                    <span className="plus-icon">+</span>
                                </button>
                            )}
                        </div>
                        <div
                            onDragStart={() => {
                                setDraggedStepIndex(i);
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={() => {
                                if (!isDisabled && draggedStepIndex !== null) {
                                    reorderSteps(draggedStepIndex, i);
                                    setDraggedStepIndex(null);
                                }
                            }}
                            onDropCapture={(e) => {
                                if (e.dataTransfer.getData('action')) {
                                    handleDropAction(step.id, e.dataTransfer.getData('action'));
                                }
                            }}
                            onDragEnd={() => {
                                setDraggedStepIndex(null);
                            }}
                            className={`step-container ${draggedStepIndex === i ? 'dragged' : ''}`}
                        >
                            {renderStepContent(step)}
                        </div>
                        {renderConditionalSteps(step)}
                    </div>
                );
                i++;
            } else {
                // For regular steps
                renderedSteps.push(
                    <div key={step.id} className="step-wrapper">
                        <div className="d-flex justify-content-center align-items-center">
                            {i > 0 && (
                                <button
                                    className="insert-step-btn"
                                    onClick={() => {
                                        if (!isDisabled) {
                                            const newStep = { id: steps.length + 1, actions: [] };
                                            const newSteps = [...steps];
                                            newSteps.splice(i, 0, newStep);
                                            setSteps(newSteps.map((step, idx) => ({
                                                ...step,
                                                id: idx + 1
                                            })));
                                        }
                                    }}
                                    title="Add step between"
                                    disabled={isDisabled}
                                >
                                    <span className="arrow-icon">↓</span>
                                    <span className="plus-icon">+</span>
                                </button>
                            )}
                        </div>
                        <div
                            onDragStart={() => {
                                setDraggedStepIndex(i);
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={() => {
                                if (!isDisabled && draggedStepIndex !== null) {
                                    reorderSteps(draggedStepIndex, i);
                                    setDraggedStepIndex(null);
                                }
                            }}
                            onDropCapture={(e) => {
                                if (e.dataTransfer.getData('action')) {
                                    handleDropAction(step.id, e.dataTransfer.getData('action'));
                                }
                            }}
                            onDragEnd={() => {
                                setDraggedStepIndex(null);
                            }}
                            className={`step-container ${draggedStepIndex === i ? 'dragged' : ''}`}
                        >
                            {step.actions.length > 0 ? (
                                renderStepContent(step)
                            ) : (
                                <div className="text-center text-primary">
                                    + Add Action Here
                                </div>
                            )}
                        </div>
                    </div>
                );
                i++;
            }
        }
        
        return renderedSteps;
    };

    return (
        <div style={{ padding: '0',height:"calc(100vh - 100px)",overflowY:"hidden" }} >
            <div 
                className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded" 
                style={{ gap: '20px', flexWrap: 'wrap', border: '1px solid rgb(227, 227, 227)' }}>
                <div className='d-flex justify-content-between align-items-center w-60 gap-5'>
                    <div>
                        <label htmlFor="workflowName" style={{ display: 'block', marginBottom: '5px' }}>
                            Workflow Name:
                        </label>
                        <input
                            id="workflowName"
                            type="text"
                            value={workflowName}
                            onChange={(e) => setWorkflowName(e.target.value)}
                            placeholder="Enter workflow name"
                            style={{ padding: '6px', width: '250px' }}
                        />
                    </div>
                    <div>
                        <label htmlFor="customRequestSelect" style={{ display: 'block', marginBottom: '5px' }}>
                            Select Custom Request:
                        </label>
                        <select
                            id="customRequestSelect"
                            value={selectedRequest}
                            onChange={(e) => {
                                const selected = e.target.value;
                                setSelectedRequest(selected);
                                setSteps([{ id: 1, actions: [] }]);
                            }}
                            style={{ padding: '6px', width: '250px' }}
                        >
                            <option value="">Select Custom Request</option>
                                {customRequestList.map((req) => (
                                    <option key={req.id} value={req.id}>
                                        {req.name}
                                    </option>
                                ))}
                        </select>
                    </div>
                </div>


                <button
                    onClick={saveWorkflow}
                    disabled={isDisabled || steps.length === 0}
                    className="btn btn-primary"
                    style={{ height: '38px', alignSelf: 'flex-end' }}
                >
                    Save Workflow
                </button>
            </div>

            <div className="workflow-layout" style={{ display: 'flex', gap: '20px',height:"calc(100% - 125px)" }}>
                {/* Left Panel */}
                <div className="left-panel smallScrollbar" style={{ flex: 1, position: 'relative',overflowY:"auto",height:"100%" }}>
                    <div className="d-flex flex-column align-items-center">
                        {renderSteps()}
                        {isDisabled ? (
                            <div className="mt-3" style={{ textAlign: 'center' }}>
                                Please select a custom request to start building the workflow.
                            </div>
                        ) : (
                            <button 
                                onClick={addStep} 
                                className="btn btn-primary mt-3"
                                disabled={isDisabled || (steps?.length>0 && steps?.[steps?.length-1]?.actions?.length===0)}
                            >
                                + Add Step
                            </button>
                        )}
                    </div>
                </div>

                {/* Right Panel */}
                <div className="right-panel smallScrollbar" style={{overflowY:"auto",height:"100%"}}>
                    <div className="actions-container">
                        <h5 className='mb-3'>Available Actions</h5>
                        <div className="d-flex flex-wrap justify-content-between align-items-center" style={{gap:"10px 0"}}>
                            {actionTypes.map((action) => (
                                <div
                                    key={action.id}
                                    draggable={!isDisabled}
                                    onDragStart={(e) => e.dataTransfer.setData('action', JSON.stringify(action))}
                                    style={{
                                        padding: '10px',
                                        background: '#fff',
                                        border:"1px solid #cacaca",
                                        borderRadius: '4px',
                                        cursor: isDisabled ? 'not-allowed' : 'grab',
                                        opacity: isDisabled ? 0.5 : 1,
                                        width:"100%"
                                    }}
                                >
                                    <i className={`${action.icon} me-2`}></i>  {action.label}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <ActionConfigModal
                    show={showModal}
                    action={currentAction}
                    onSave={handleModalSave}
                    onClose={() => setShowModal(false)}
                    allTableList={allTableList}
                    selectedRequest={selectedRequest}
                    allSteps={steps}
                    currentStepId={currentStepId}
                />
            )}

            {showStepDetails && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Step Details</h5>
                                <button type="button" className="btn-close" onClick={() => setShowStepDetails(null)}></button>
                            </div>
                            <div className="modal-body">
                                {renderActionConfigDetails(steps.find(s => s.id === showStepDetails)?.actions[0], allTableList)}
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default WorkflowBuilder;
